import { makeStyles, css } from '@conexasaude/styles'

const useStyles = makeStyles({
  container: ({ colors }) => css`
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: ${colors.common.white};
    img {
      width: 130px;
    }
  `,
})

export { useStyles }
